import { AppState, PageProps, Session } from "@declarations"
import { getTopViewedEpisodes } from "Store/Actions/DataActions-VisitorBehavior"
import Table from "Components/Table/Table"
import { useEffect } from "react"
import Skeleton from "react-loading-skeleton"
import { connect } from "react-redux"
import { store } from "Store/store"
import EmptyState from "Components/EmptyState/EmptyState"
import { callCheck } from "Utils/data"

interface Props extends PageProps<typeof mapStateToProps, typeof mapDispatchToProps> {
}

const TopViewedEpisodesTable = (props: Props) => {

    const { session, experiences, episodeList, getEpisodeList, loadingData, demoBrandActive, globalView } = props

    useEffect(() => {

        if (!callCheck(globalView, (session as Session.AuthSession).user.admin, experiences?.length)) return

        getEpisodeList()

    }, [experiences, getEpisodeList, session, demoBrandActive, globalView])

    return (
        <div >
            {
                loadingData
                    ? <Skeleton height={500} className="table-skeleton-shared-box" />
                    : episodeList && episodeList.length
                        ? <Table
                            title="Top Viewed Episodes"
                            titleTooltip=""
                            showTitle={false}
                            headers={Object.keys(episodeList[0])}
                            sortable={["episodeTitle"]}
                            tooltipable={[
                                { header: "scans", text: "These are defined as an individual instance where a visitor scans a QR code." },
                                { header: "sessions", text: "These are defined as when a visitor spends 10+ seconds viewing an experience." }
                            ]}
                            data={episodeList}
                            limit={20}
                            pagination={true}
                        />
                        : <EmptyState filterableData={false} />
            }
        </div>
    )
}

const mapStateToProps = (state: AppState) => {
    return {
        session: state.session,
        experiences: state.experiences.experienceIdList,
        demoBrandActive: state.experiences.demoBrandActive,
        globalView: state.experiences.globalView,
        episodeList: state.data.visitorBehavior.topViewedEpisodes.topViewedEpisodes,
        loadingData: state.loading.visitorBehavior.topViewedEpisodes.topViewedEpisodes
    }
}
const mapDispatchToProps = (dispatch: typeof store.dispatch) => {
    return {
        getEpisodeList: () => dispatch(getTopViewedEpisodes())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TopViewedEpisodesTable)